import { API_ROOT, COUNTRY_CODE_MAP } from "./constant";

// Dashboard API Endpoints
export const DASHBOARD_API = {
  BP_DASHBOARD: `${API_ROOT}/dashboard/bp`,
  CCM_DASHBOARD: `${API_ROOT}/dashboard/ccm`,
  CCM_AUTO_APPROVAL_RATE: `${API_ROOT}/dashboard/ccm/autoApprovalRate`,
  EXTENSION_REQUESTS: `${API_ROOT}/dashboard/extension-requests`,
  PENDING_ERRORS: `${API_ROOT}/dashboard/pending-errors`,
  PENDING_BP_CHECK: `${API_ROOT}/dashboard/pending-bp-check`,
};

// Table Column Configurations
export const EXTENSION_REQUEST_COLUMNS = [
  {
    field: "country",
    headerName: "",
    width: 150,
    flex: 1,
    headerClassName: "white-header",
    renderCell: (params) => (COUNTRY_CODE_MAP[params.value] || params.value),
  },
  {
    field: "bp",
    headerName: "BP",
    width: 100,
    flex: 0.8,
    align: "right",
    headerAlign: "right",
    headerClassName: "white-header",
    renderCell: (params) => {
      const value = params.value;
      return (
        <span style={{ color: "#0a7d2e", textDecoration: "underline", cursor: "pointer" }}>
          {value}
        </span>
      );
    },
  },
  {
    field: "ccm",
    headerName: "CCM",
    width: 100,
    flex: 0.8,
    align: "right",
    headerAlign: "right",
    headerClassName: "white-header",
    renderCell: (params) => {
      const value = params.value;
      return (
        <span style={{ color: "#0a7d2e", textDecoration: "underline", cursor: "pointer" }}>
          {value}
        </span>
      );
    },
  },
];

export const PENDING_ERRORS_COLUMNS = [
  {
    field: "country",
    headerName: "Country",
    width: 150,
    flex: 1,
    renderCell: (params) => (COUNTRY_CODE_MAP[params.value] || params.value),
  },
  {
    field: "errors",
    headerName: "Errors",
    width: 100,
    flex: 0.8,
    align: "right",
    headerAlign: "right",
    renderCell: (params) => {
      const value = params.value;
      return (
        <span style={{ color: "#0a7d2e", textDecoration: "underline", cursor: "pointer" }}>
          {value}
        </span>
      );
    },
  },
];

export const PENDING_BP_CHECK_COLUMNS = [
  {
    field: "country",
    headerName: "Country",
    width: 150,
    flex: 1,
    renderCell: (params) => (COUNTRY_CODE_MAP[params.value] || params.value),
  },
  {
    field: "pending",
    headerName: "Pending",
    width: 100,
    flex: 0.8,
    align: "right",
    headerAlign: "right",
    renderCell: (params) => {
      const value = params.value;
      return (
        <span style={{ color: "#0a7d2e", textDecoration: "underline", cursor: "pointer" }}>
          {value}
        </span>
      );
    },
  },
];

// Dashboard Card Titles
export const DASHBOARD_TITLES = {
  EXTENSION_APPLICATION: "Extension Application",
  PENDING_EXTENSION_REQUESTS: "Pending Extension Requests",
  PENDING_ERRORS: "Pending Errors",
  INTEREST_BEARING: "Interest Bearing",
  PENDING_BP_CHECK: "Pending BP Check",
};


